import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class User_AdviserAbsenceScheduled extends _Event {
    constructor(payload: EventSchema<User_AdviserAbsenceScheduled>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            absenceFrom: z.coerce.date(),
            absenceUntil: z.coerce.date(),
            delegateId: schemaId,
            reason: z.optional(z.string().min(1)),
        });
    }

    static example(): EventSchema<User_AdviserAbsenceScheduled> {
        return {
            absenceFrom: new Date('2023-07-17T12:12:16.000Z'),
            absenceUntil: new Date('2024-08-18T20:05:00.000Z'),
            delegateId: '5bd92cb6-90bb-45e9-9a70-d9a18d7f069f',
            reason: 'Parental Leave',
        };
    }
}
